'use client';

import Button from '@enlighten/design-system/dist/Button';
import Dialog from '@enlighten/design-system/dist/Dialog';
import Grid from '@enlighten/design-system/dist/Grid';
import Close from '@mui/icons-material/Close';

export interface YouTubeDialogProps {
	open: boolean;
	onClose?(): void;
	src: string;
}

export default function YouTubeDialog({ open, onClose, src }: YouTubeDialogProps) {
	return (
		<Dialog
			open={open}
			onClose={(_, reason) => {
				if (reason === 'backdropClick') {
					onClose && onClose();
				}
			}}
			slotProps={{
				paper: {
					sx: {
						bgcolor: 'transparent',
						maxWidth: { xs: '100%', md: 937 },
						width: '100%',
						height: { md: 580 },
						borderRadius: 0,
						boxShadow: 'none',
					},
				},
			}}
			sx={{
				'& iframe': {
					aspectRatio: '16 / 9',
					border: 'none',
				},
			}}
		>
			<Grid container justifyContent="flex-end" alignItems="center">
				<Button
					disableRipple
					variant="text"
					title="close"
					onClick={() => {
						onClose && onClose();
					}}
					sx={{
						padding: '2px 0 2px 2px',
						':hover': {
							bgcolor: 'transparent',
						},
					}}
				>
					<Close fontSize="medium" sx={{ color: 'common.white' }} />
				</Button>
			</Grid>
			<iframe title="iframe" width="100%" height="100%" src={src} allow="accelerometer; muted; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
		</Dialog>
	);
}
